import { useEffect, useState } from "react";
import { useParams, Link, } from "react-router-dom";
import { Helmet } from "@dr.pogodin/react-helmet";
import { fetchCaseStudyBySlug } from "../services/API";

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const [caseStudy, setCaseStudy] = useState(null);
  const backendUrl = import.meta.env.VITE_BACKEND_API_URL;

  useEffect(() => {
    fetchCaseStudyBySlug(slug).then(setCaseStudy);
  }, [slug]);

  if (!caseStudy) return <div className="container py-5">Loading...</div>;

  const industries = caseStudy.industry?.map((i) => i.name).join(", ") || "-";
  const regions = caseStudy.region?.map((r) => r.name).join(", ") || "-";

  const createFilterQuery = (filterType, value) => {
    return `?${filterType}=${encodeURIComponent(value)}`;
  };

  return (
    <div className="container py-5">
      <Helmet>
        <title>{caseStudy.metaTitle || caseStudy.title}</title>
        <meta name="description" content={caseStudy.metaDescription || caseStudy.shortDescription} />
        <meta property="og:title" content={caseStudy.metaTitle || caseStudy.title} />
        <meta property="og:description" content={caseStudy.metaDescription || caseStudy.shortDescription} />
        <meta property="og:image" content={`${backendUrl}/uploads/case-study-tile/images/${caseStudy.caseStudyThumb}`} />
      </Helmet>

      <div className="caseStudyDeatilBanner">
        <img src={`${backendUrl}/uploads/case-study-tile/images/${caseStudy.caseStudyThumb}`}
          className="card-img-top"
          alt={caseStudy.title}
        />
      </div>

      <div className="caseStudyDeatilMobileBanner">
        <img src={`${backendUrl}/uploads/case-study-tile/images/${caseStudy.caseStudyThumbForMobile}`}
          className="card-img-top"
          alt={caseStudy.title}
        />
      </div>

      <h1 className="case-study-title">{caseStudy.title}</h1>
      <p className="text-muted">
        <Link to={`/case-studies${createFilterQuery('category', caseStudy.category?.name)}`}>{caseStudy.category?.name}</Link> | 
        <Link to={`/case-studies${createFilterQuery('platform', caseStudy.platform?.name)}`}>{caseStudy.platform?.name}</Link> | 
        <Link to={`/case-studies${createFilterQuery('industry', industries)}`}>{industries}</Link> | 
        <Link to={`/case-studies${createFilterQuery('region', regions)}`}>{regions}</Link>
      </p>
      <hr />
      <div dangerouslySetInnerHTML={{ __html: caseStudy.content || caseStudy.description }} />
    </div>
  );
}
